@if (disabled()) {
  <span hlmBadge [class]="getStatusColor(currentStatus())" class="inline-flex h-6 items-center gap-1.5 rounded-md px-2 font-mono text-xs font-normal">
    <span class="size-1.5 rounded-full bg-current" aria-hidden="true"></span>
    {{ getStatusLabel(currentStatus()) }}
  </span>
} @else {
<button
  hlmBadge
  [class]="getStatusColor(currentStatus())"
  [class.opacity-50]="disabled()"
  [class.cursor-not-allowed]="disabled()"
  [class.cursor-pointer]="!disabled()"
  [class.hover:opacity-80]="!disabled()"
  class="h-6 rounded-md pl-2 pr-1.5 font-mono text-xs font-normal transition-opacity inline-flex items-center gap-1.5 whitespace-nowrap [&[aria-expanded=true]>ng-icon]:rotate-180"
  [brnMenuTriggerFor]="statusMenu"
  [disabled]="disabled()"
>
  <span class="size-1.5 rounded-full bg-current" aria-hidden="true"></span>
  {{ getStatusLabel(currentStatus()) }}
  <ng-icon name="lucideChevronDown" class="size-3 transition-transform duration-150"></ng-icon>
</button>

<ng-template #statusMenu>
  <hlm-menu class="w-48">
    <hlm-menu-group>
      <hlm-menu-label>Status ändern</hlm-menu-label>
      <hlm-menu-separator />

      @for (option of availableStatusOptions(); track option.value) {
      <button
        hlmMenuItem
        (click)="onStatusSelect(option.value)"
        [class.bg-accent]="currentStatus() === option.value"
        [disabled]="currentStatus() === option.value"
      >
        <span hlmBadge [class]="getStatusColor(option.value)" class="inline-flex h-6 items-center gap-1.5 rounded-md px-2 font-mono text-xs whitespace-nowrap">
          <span class="size-1.5 rounded-full bg-current" aria-hidden="true"></span>
          {{ option.label }}
        </span>
        @if (currentStatus() === option.value) {
        <span class="ml-auto text-xs text-muted-foreground">✓</span>
        }
      </button>
      }
    </hlm-menu-group>
  </hlm-menu>
</ng-template>
}
